import { FC, useEffect, useState } from 'react';
import { ThinButton } from '../../Buttons/ThinButton/ThinButton';
import { Modal } from '../../Modal/Modal';
import { miniApp } from '@telegram-apps/sdk';
import { useTracking } from '../../../hooks/traking';
import { ISessionInfo } from '../../../types/session';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../Menu/MenuButton';
import { useSelector } from '../../../hooks';
import { ChallengeCategory } from '../../../redux/challenges';
import { trueFragmentsForm } from '../../../utils/true.word.form';
import { getPlatform, Platform } from '../../../platform/platform';

interface IConfirmExitProps {
    cancelHandler: () => void;
}

export const ConfirmExit: FC<IConfirmExitProps> = ({ cancelHandler }) => {
    const { trackCustom } = useTracking('App');
    const { trackClick } = useTracking('ConfirmExit');

    const navigate = useNavigate();

    const [fragments, setFragments] = useState<number | null>(null);
    const challenges = useSelector(store => store.challenges.items);    

    useEffect(() => {
        if (!challenges || challenges.length === 0) {
            return;
        }

        const fragments = challenges
            .filter(item => item.category === ChallengeCategory.Tutorial)
            .filter(item => item.progress < item.milestones[item.milestones.length - 1].threshold)
            .reduce((totalAcc, challenge) => {
                totalAcc += challenge.milestones.reduce((acc, milestone) => {
                    if (milestone.reward.fragments)
                        acc += milestone.reward.fragments;
                    return acc;
                }, 0);
                return totalAcc;
            }, 0);

        setFragments(fragments);
    }, [challenges]);

    const onCloseApp = () => {        
        const sessionInfoStr = localStorage.getItem('sessionInfo');
        if (sessionInfoStr) {
            const sessionInfo: ISessionInfo = JSON.parse(sessionInfoStr);
            const value = new Date().getTime() - sessionInfo.start;
            trackCustom('finish', { value });
        }

        if (getPlatform() === Platform.Telegram) {
            miniApp.close();
        }
    }

    const onCancel = () => {
        cancelHandler();
        trackClick('cancel');
        navigate(AppContext.Challenges);
    }

    if (fragments === 0)
        onCloseApp();

    const getMessage = () => {
        if (fragments === null)
            return;

        return (
            <div>
                <p>Сегодня еще можно получить {fragments} {trueFragmentsForm(fragments)} за испытания.</p>
                <p>Вы точно хотите выйти, упустив возможность собрать 50 фрагментов и получить сертификат на 500 руб?</p>
            </div>
        );
    }

    return (
        <Modal
            name={null}
            title='Вы кое-что забыли'
            message={ getMessage() }
            button={[
                <ThinButton caption='Посмотреть испытания' handler={ onCancel } small={true} />,
                <ThinButton caption='Выйти' handler={ onCloseApp } small={true} inverse={true} />,                
            ]}
        />
    );
}